export default {
	title: 'Převzetí kontaktu',
	client: 'Klient',
	firstName: 'Jméno klienta',
	surname: 'Příjmení klienta',
	personIn: 'Rodné číslo',
	address: 'Adresa',
	campaign: 'Kampaň',
	type: 'Typ',
	amount: 'Částka',
	policyNo: 'Číslo PS',
	sellerIn: 'Přiděleno na',
	contactState: 'Stav',
	municipality: 'Obec',
	zipCode: 'PSČ',
	minCombination1: 'Číslo PS',
	minCombination2: 'Rodné číslo',
	minCombination3: 'Příjmení + Jméno + Obec',
	minCombination4: 'Příjmení + Jméno + PSČ',
	take: 'Převzít',
};
